export default __webpack_public_path__ + "static/media/equity-banner-inner.e3b9448d.jpg";